import { useContext } from 'react';

import { sumDataTransferCost, sumDataTransferTraffic } from '@cast/utils';

import { TimeSeries } from 'types/metrics';

import { DataTransferChartDatapoint } from '../../../../cost-report/types/networkCostOverTime';
import { NetworkCostOverTimeContext } from '../../providers/NetworkCostOverTimeProvider';

export const useDataTransferChartDatapoints = (
  type: 'cost' | 'traffic'
): TimeSeries<DataTransferChartDatapoint> => {
  const { current } = useContext(NetworkCostOverTimeContext);
  return current.chartData.map((d) => {
    if ('egress' in d && 'ingress' in d) {
      return {
        timestamp: d.timestamp,
        egress:
          type === 'cost'
            ? sumDataTransferCost(d.egress)
            : sumDataTransferTraffic(d.egress),
        ingress:
          type === 'cost'
            ? sumDataTransferCost(d.ingress)
            : sumDataTransferTraffic(d.ingress),
      };
    }

    return {
      timestamp: d.timestamp,
      egress: null,
      ingress: null,
    };
  });
};
